import Chip from '@components/Chip';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import useProjectId from '@hooks/useProjectId';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import usePaymentMethods from './hooks/usePaymentMethods';
import MethodItem from './MethodItem';
import MoreIcon from './MoreIcon';
import SimplePayIcon from './SimplePayIcon';

// 카페게이트에 한해 확장 기본 처리
const cafegateId = import.meta.env.VITE_CAFEGATE_ID;

function PaymentMethod() {
    const [isSimple, setIsSimple] = useState(false);
    const projectId = useProjectId();
    const [expand, setExpand] = useState<boolean>(projectId === cafegateId);
    const { t } = useTranslation('order');
    const methodList = usePaymentMethods();
    const project = useProject();
    if (project?.pgVendor === 'TOSS') {
        return null;
    }
    return (
        <Container as='section'
            fullWidth>
            <Text size='lg' fontWeight='bold'>{t('paymentMethod.title')}</Text>
            <TypeChips variant='fill'>
                <Chip isSelected={!isSimple} onClick={() => setIsSimple(false)}>{t('paymentMethod.general')}</Chip>
            </TypeChips>
            {isSimple ? (
                <SimplePayIcon/>
            ) : (
                <Column fullWidth
                    align='center'>
                    <GridWrapper expand={expand}>
                        <Grid>
                            {methodList?.map((method) => (
                                <MethodItem method={method}
                                    key={method} />
                            ))}
                        </Grid>
                    </GridWrapper>
                    {(methodList?.length || 0) > 3 && (
                        <Column align='center'
                            onClick={() => setExpand(!expand)}
                            spacing={4}>
                            <Text color={colors.gray5}>{t('paymentMethod.morePayments')}</Text>
                            <MoreIcon css={[moreIconCss, expand && expandedMoreIconCss]}/>
                        </Column>
                    )}
                </Column>
            )}
        </Container>
    );
}

const Container = styled(Column)`
    padding: 24px 20px 0;
`;

const TypeChips = styled(Chip.Container)`
    margin-top: 20px;
`;

const Grid = styled.article`
    display: grid;
    gap: 16px 0;
    grid-template-columns: repeat(3, 1fr);
    padding: 34px 0;
    width: 100%;
`;

const GridWrapper = styled.div<{ expand: boolean }>`
    max-height: ${({ expand }) => (expand ? 432 : 128)}px;
    overflow: hidden;
    transition: max-height 200ms ease-in-out;
    width: 100%;
`;

const moreIconCss = css`
    transition: 200ms;
`;

const expandedMoreIconCss = css`
    transform: rotate(180deg);
`;

export default PaymentMethod;
